<template>
  <v-col
    v-if="isIf"
    :key="field.id"
    :cols="field.column"
  >
    <naj-input
      v-if="isShow"
      :class="{ 'with-other-option': hasOtherOptionSelected(field)}"
      :type-id="field.typeId"
      :label="field.label"
      :disabled="isDisabled || isDimmed"
      :value.sync="formModel[field.name]"
      :value-name.sync="valueNameBinder"
      :technical-name="field.name"
      :items="getItems(field)"
      :validates="field.validations"
      :counter="field.maxLength"
      :item-text="field.itemText || 'name'"
      :item-value="field.itemValue || 'id'"
      :item-description="field.itemDescription || 'description'"
      :item-tooltip="field.itemToolTip || 'tooltip'"
      :item-icon="field.itemIcon || 'icon'"
      :tooltip-content="field.showDescriptionTooltip ? field.description : null"
      v-bind="dynamicProps"
      @mounted="onEvent('onMounted', $event)"
      @input="onEvent('onInput', $event)"
      @change="onEvent('onChange', $event)"
    ></naj-input>
    <div
      v-if="hasOtherOptionSelected(field)"
      :ref="`${field.name}-other`"
      class="with-other-option other-option-box"
    >
      <naj-input
        class="other-option"
        :type-id="formFieldType.text"
        :value.sync="formModel[`${field.name}-other`]"
        :technical-name="`${field.name}-other`"
        :label="`${field.label} آخر`"
        :disabled="viewMode"
        :validates="`required|error:${local.shared.shouldAddedToList(field.label)}`"
      ></naj-input>
      <naj-button
        square
        :disabled="!formModel[`${field.name}-other`]"
        @click="addOtherOption(field)"
      >
        {{ local.common.add }}
      </naj-button>
    </div>
  </v-col>
</template>

<script>
import { convertToValidTechnicalName, executeString } from '@/helpers/utils';
export default {
  name: 'NajDynamicField',
  inject: ['$validator'],
  props: {
    field: {
      type: Object,
      required: true,
    },
    formModel: {
      type: Object,
      required: true,
    },
    rootFormModel: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    dataSources: {
      type: Object,
      required: true,
    },
    viewMode: {
      type: Boolean,
      required: true,
    },
    requiredData: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  data() {
    return {
      executeString,
      valueNameBinder: null,
      tempValue: null,
    };
  },
  computed: {
    isIf() {
      const returnValue = this.executeStringWithRootContext(this.field.if);
      if (!returnValue && ((this.formModel || {}).shown || {})[convertToValidTechnicalName(`${this.field.name}_${this.field.id}`)] !== undefined && ((this.formModel || {}).shown || {})[convertToValidTechnicalName(`${this.field.name}_${this.field.id}`)] !== returnValue)
        this.resetFieldValue();
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      if (!this.formModel.shown) this.formModel.shown = {};
      this.$set(this.formModel.shown, convertToValidTechnicalName(`${this.field.name}_${this.field.id}`), returnValue);
      return returnValue;
    },
    isShow() {
      const returnValue = this.executeStringWithRootContext(this.field.show);
      if (!returnValue && ((this.formModel || {}).shown || {})[convertToValidTechnicalName(`${this.field.name}_${this.field.id}`)] !== undefined && ((this.formModel || {}).shown || {})[convertToValidTechnicalName(`${this.field.name}_${this.field.id}`)] !== returnValue)
        this.resetFieldValue();
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      if (!(this.formModel || {}).shown) (this.formModel || {}).shown = {};
      this.$set(this.formModel.shown, convertToValidTechnicalName(`${this.field.name}_${this.field.id}`), returnValue);
      return returnValue;
    },
    isDisabled() {
      const returnValue = this.executeStringWithRootContext(this.field.disabledIf);
      returnValue && this.resetFieldValue();
      return this.viewMode || returnValue;
    },
    isDimmed() {
      const returnValue = this.executeStringWithRootContext(this.field.isDimmed);
      return this.viewMode || returnValue;
    },
    dynamicProps() {
      const returnValue = {};
      if (this.field.typeId == this.formFieldType.date && this.field.dateConfig.max) returnValue['maxDate'] = this.field.dateConfig.max;
      if (this.field.typeId == this.formFieldType.date && this.field.dateConfig.acceptFutureDate) returnValue['maxDate'] = null;
      if (this.field.isLTR) returnValue['dir'] = 'ltr';
      return returnValue;
    },
  },
  watch: {
    valueNameBinder(value) {
      if (this.field.textName)
        this.$set(this.formModel, this.field.textName, value);
      else
        this.$set(this.formModel, this.field.textName, undefined);
    },
  },
  created() {
    if (this.field.textName && this.formModel[this.field.textName])
      this.valueNameBinder = this.formModel[this.field.textName];
  },
  methods: {
    getItems(field) {
      if ((field.externalDataSource || {}).endpoint)
        return this.getFilteredExternalDataSource(field);
      else if ((field.internalDataSource || {}).source) {
        return this.getInternalDataSource(field);
      }
      else
        return field.items;
    },
    getFilteredExternalDataSource(field) {
      const dataSource = this.dataSources[`${field.id}${field.name}`] || [];
      const filtrationKey = field.externalDataSource.filtrationKey || 'id';
      const filtrationItems = field.externalDataSource.filtrationItems || [];
      return dataSource
        .filter(ds => ds[filtrationKey] === this.formModel[field.name]
          || !(filtrationItems).some(fi => fi[field.name] === ds[filtrationKey]));
    },
    getInternalDataSource(field) {
      const source = field.internalDataSource.source;
      const formSource = field.internalDataSource.formSource;
      const data = {
        ...this.requiredData,
        ...this.rootFormModel,
        formGrids: this.extractAndFlattenArrays(this.rootFormModel),
      };
      return formSource ? ((data || {})[source] || {})[formSource] : (data || {})[source];
    },
    extractAndFlattenArrays(obj) {
      var grids = {};
      if (obj && typeof obj === 'object') {
        Object.keys(obj)
          .forEach((key) => {
            if (obj[key] && Array.isArray(obj[key]) && obj[key].length) {
              grids[key] = obj[key];
              obj[key].forEach((innerObj) => {
                grids = {
                  ...grids,
                  ...this.extractAndFlattenArrays(innerObj),
                };
              });
            }
            if (obj[key] && typeof obj[key] === 'object') {
              grids = {
                ...grids,
                ...this.extractAndFlattenArrays(obj[key]),
              };
            }
          });
      }
      return grids;
    },
    addOtherOption(field) {
      this.$emit('addOtherOption', field);
    },
    hasOtherOptionSelected(field) {
      this.$emit('hasOtherOptionSelected', field);
    },
    resetFieldValue() {
      if (this.tempValue !== null && this.formModel[this.field.name] == this.tempValue && this.formModel[this.field.name] !== undefined) {
        setTimeout(() => {
          this.$set(this.formModel, this.field.name, undefined);
          if (this.field.textName && this.formModel[this.field.textName] !== undefined)
            this.$set(this.formModel, this.field.textName, undefined);
        }, 50);
        this.tempValue = null;
      }
    },
    onEvent(eventName, $event) {
      this.tempValue = this.formModel[this.field.name];
      if (this.field[eventName]) this.field[eventName]($event);
    },
    executeStringWithRootContext(params) {
      return this.executeString(params, {
        ...this.requiredData,
        ...this.rootFormModel,
        ...this.formModel,
        $set: this.$set,
        $push: this.$push,
        $delete: this.$delete,
      });
    },
  },
};
</script>
